import { Logger as o } from "./contact-channels50.js";
class t {
  /**
   * Logs an info level message to New Relic.
   * @param {string} pageAction - The page action name.
   * @param {NRAttributes} data - The log data.
   */
  static info(r, i) {
    o.info(`NewRelic: ${r}`, i), this.log("info", r, i);
  }
  /**
   * Logs an error level message to New Relic.
   * @param {string} pageAction - The page action name.
   * @param {NRErrorAttributes} data - The log data.
   */
  static error(r, i) {
    o.error(`NewRelic: ${r}`, i), this.log("error", r, i);
  }
  static warn(r, i) {
    o.warn(`NewRelic: ${r}`, i), this.log("warn", r, i);
  }
  static noticeError(r) {
    window != null && window.newrelic && window.newrelic.noticeError(r);
  }
  static log(r, i, e) {
    if (!window || !window.newrelic) {
      console.error("Logger not Initialized");
      return;
    }
    window.newrelic.addPageAction(i, {
      ...e,
      logLevel: r
    });
  }
}
export {
  t as NRLogger
};
//# sourceMappingURL=contact-channels45.js.map
